// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19 2V4L5 4V2H19Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3 7.5L21 7.5V5.5L3 5.5V7.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 22V9L1 9V22H23ZM15 15.5001L9.75 18.5312V12.469L15 15.5001Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-media-library-filled')
export default class MediaLibraryFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'media-library-filled',
    }
  }
}
